module.exports = __webpack_public_path__ + "toBride1-we-y-w.22bb48cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-y-w.jpg
// module id = bBz5
// module chunks = 0